import { useEffect, useState } from "react";

export default function usePricing() {
    const [pricing, setPricing] = useState({monthly: 4.99, annual: 49});

    useEffect(() => {
        //load and set price 
    }, []);

    return pricing;
}
